<template lang="pug">
div
  label.app-filter
    span.app-filter__inner
      input.app-filter__input(type="checkbox" :id="filter.id" v-model="model" :disabled="forceChecked")
      span.app-filter__value {{ filter.value }}
      span.app-filter__count(v-if="filter.countDisplay") ({{ filter.countDisplay }})
      button.app-filters__toggle(@click="toggle('open')" v-if="filter.filters && filter.filters.length" :class="{open}" type="button" :aria-label="filterToggleLabel")
  .app-filter__children(v-if="filter.filters && filter.filters.length")
    TransitionExpand
      AppFilter(
        v-if="open"
        v-for="(childFilter, i) in relevantFilters"
        :key="'f2'+childFilter.id"
        :filter="childFilter"
        :forceChecked="model"
        :executeSearch="executeSearch"
        :setFilterValue="setFilterValue")
</template>
  
<script>
import TransitionExpand from '../../global/transitions/Expand.vue'

export default {
  name: "AppFilter",
  props: ["filter", "setFilterValue", "initiallyExpanded", "forceChecked", 'executeSearch', 'showZeroResultFilters'],
  components: { TransitionExpand },
  data() {
    return {
			open: this.initiallyExpanded || (this.filter.filters && this.filter.filters.some(x => x.selected))
    };
  },
  computed: {
    model: {
      get() {
        return this.filter.selected || this.forceChecked;
      },
      set(value) {
        this.setFilterValue(this.filter, value);
        this.executeSearch();
      }
    },
		relevantFilters() {
			if (this.config.isLrlPage) return this.filter.filters.filter((x) => x.count >= 0);
			return this.filter.filters.filter((x) => x.count > 0);
		}
  },
  methods: {	
    toggle(state) {
      this[state] = !this[state];
    },
    
		filterToggleLabel() {
			let keyword = this.open ? 'Hide' : 'Show';
			return keyword + ' filter options for ' + this.group.name;
		},
  },
  watch: {
    forceChecked(newVal, oldVal) {
      if (this.filter.selected) {
        this.model = false
      }
    }
  },
  created() { },
  mounted() { },
};
</script>

<style lang="scss">
.app-filters {
	&__toggle {
		padding: 0.3rem 0.5rem;
	}
}

.app-filter {
  &:focus-within:not(body.using-mouse *) {
    box-shadow: 0 0 0 2px $red;
  }
}
</style>

<style lang="scss" scoped>
.app-filter {
  display: flex;
  font-size: 0.875rem;
  cursor: pointer;

  &:first-of-type {
    .app-filter__inner {
      padding-top: 0.75rem;
    }
  }

  &__children {
    margin-left: 1rem;
  }

  &__inner {
    display: flex;
    justify-content: space-between;
    gap: 0.5rem;
    padding: 0.375rem 0;
  }

  &__input {
    @include hideVisually;

    .page--RM &:checked+.app-filter__value::before {
      background: $blue;
    }
    .page--ORG &:checked+.app-filter__value,
    .page--TSP &:checked+.app-filter__value,
    .page--TXC &:checked+.app-filter__value,
    .page--BUY &:checked+.app-filter__value,
    .page--BOB &:checked+.app-filter__value {
			&::after {
				opacity: 1;
			}
		}
		.page--ORG &:checked+.app-filter__value {
			&::before {
				background: $yellowAltOrg;
			}
		}
		.page--TSP &:checked+.app-filter__value {
			&::before {
				background: $secondarytsp;
			}
		}
		.page--TXC &:checked+.app-filter__value {
			&::before {
				background: $secondarytxc;
			}
		}
		.page--BUY &:checked+.app-filter__value {
			&::before {
				background: $secondarybuy;
			}
		}
		.page--BOB &:checked+.app-filter__value {
			&::before {
				background: $secondary300bob;
			}
		}
  }

  &__input {
    &:disabled+.app-filter__value,
    .page--RM &:disabled+.app-filter__value,
    .page--ORG &:disabled+.app-filter__value,
    .page--TSP &:disabled+.app-filter__value,
    .page--TXC &:disabled+.app-filter__value,
    .page--BOB &:disabled+.app-filter__value,
    .page--BUY &:disabled+.app-filter__value {
      &::before {
        background: $midGray;
      }
      &::after {
        color: $darkGray;
      }
    }
  }

  &__value {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 0.5rem;
    justify-content: center;

    &::before,
    &::after {
      content: '';
      grid-area: 1 / 1 / 2 / 2;
    }

    &::before {
      height: 1rem;
      width: 1rem;
      border: 1px solid $gray;
      border-radius: 3px;
      transition: 0.15s ease;
      background: $white;
    }

    &::after {
      .page--RM & {
        height: 0.625rem;
        width: 0.275rem;
        border-bottom: 1px solid $white;
        border-right: 1px solid $white;
        transform: translateY(2px) rotate(45deg);
        justify-self: center;
      }
      .page--ORG &,
      .page--TSP &,
      .page--TXC &,
      .page--BOB &,
      .page--BUY & {
        @include icon;
        content: "\e95b";
        font-size: 0.625rem;
        height: 1rem;
        width: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0;
      }
    }
  }

  &__count {
    color: lighten($gray, 5);
  }
}
</style>